
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import NotFound from '../pages/NotFound';
import Services from '../pages/services/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import GRIPage from '../pages/services/gri/page';
import TSRSPage from '../pages/services/tsrs/page';
import CSRDPage from '../pages/services/csrd/page';
import ESGPage from '../pages/services/esg/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/hizmetler',
    element: <Services />
  },
  {
    path: '/hizmetler/gri-surdurulebilirlik-raporu',
    element: <GRIPage />
  },
  {
    path: '/hizmetler/tsrs-surdurulebilirlik-raporu',
    element: <TSRSPage />
  },
  {
    path: '/hizmetler/csrd-surdurulebilirlik-raporu',
    element: <CSRDPage />
  },
  {
    path: '/hizmetler/esg-danismanligi',
    element: <ESGPage />
  },
  {
    path: '/hakkimizda', 
    element: <About />
  },
  {
    path: '/iletisim',
    element: <Contact />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
